export default __webpack_public_path__ + "static/media/bgCompany.ea4915f4.svg";